import gql from 'graphql-tag';

export const GetUnleashFeatureToggles = gql`
  query UnleashFeatureToggle {
    unleashFeatureToggles {
      name
      enabled
    }
  }
`;

export const visibilityMutation = gql`
  mutation visibilityMutation($attributes: WWS_WeddingWebsiteAttributes!) {
    updateWeddingWebsite(attributes: $attributes) {
      id
      searchable
    }
  }
`;
export const GetAttireCategories = gql`
  query GetAttireCategories {
    attireCategories {
      id
      label
      description
    }
  }
`;

export const deletePageItem = gql`
  mutation deletePageItem($attributes: WWS_DeletePageItemAttributes!) {
    deletePageItem(attributes: $attributes)
  }
`;

export const GetThemeFilterOptions = gql`
  query GetThemeFilterOptions {
    themeFilterOptions {
      colors
      seasons
      themeStyles {
        label
        key
      }
    }
  }
`;
